module.exports = __webpack_public_path__ + "static/template_list_day_split_timeslots-ddfbb792d820d7e70203504d9a46995f.png";